'use client'
import { WalletsView } from '../../views/WalletsView/WalletsView.js';
import { ProfileView } from '../../views/ProfileView/ProfileView.js';
import { EditProfileView } from '../../views/EditProfileView/EditProfileView.js';
import { SendBalanceWidgetView } from '../../views/SendBalanceWidgetView/SendBalanceWidgetView.js';
import { ManagePasskeysWidgetView } from '../../views/ManagePasskeysWidgetView/ManagePasskeysWidgetView.js';
import { SettingsView } from '../../views/SettingsView/SettingsView.js';
import { AccountAndSecuritySettingsView } from '../../views/AccountAndSecuritySettingsView/AccountAndSecuritySettingsView.js';
import { SessionManagementView } from '../../views/SessionManagementView/SessionManagementView.js';
import { ChooseLinkedWalletView } from '../../views/ChooseLinkedWalletView/ChooseLinkedWalletView.js';
import { ChooseOnrampProviderView } from '../../views/ChooseOnrampProviderView/ChooseOnrampProviderView.js';
import { ChooseWalletFundingMethod } from '../../views/ChooseWalletFundingMethod/ChooseWalletFundingMethod.js';
import { ConfirmExchangeTransferView } from '../../views/ConfirmExchangeTransferView/ConfirmExchangeTransferView.js';
import { ConnectedAppsView } from '../../views/ConnectedAppsView/ConnectedAppsView.js';
import { DepositedExchangeView } from '../../views/DepositedExchangeView/DepositedExchangeView.js';
import { DepositView } from '../../views/DepositView/DepositView.js';
import { GlobalWalletView } from '../../views/GlobalWalletView/GlobalWalletView.js';
import { ManageMfaWidgetView } from '../../views/ManageMfaWidgetView/ManageMfaWidgetView.js';
import { ReceiveWalletFunds } from '../../views/ReceiveWalletFunds/ReceiveWalletFunds.js';
import { RevokeAccessView } from '../../views/SessionManagementView/RevokeAccessView/RevokeAccessView.js';
import { SessionManagementInfoView } from '../../views/SessionManagementView/SessionManagementInfoView/SessionManagementInfoView.js';

const mapViewToComponent = {
    'account-and-security-settings': AccountAndSecuritySettingsView,
    'choose-linked-wallet': ChooseLinkedWalletView,
    'choose-onramp-provider': ChooseOnrampProviderView,
    'choose-wallet-funding-method': ChooseWalletFundingMethod,
    'confirm-exchange-transfer': ConfirmExchangeTransferView,
    'connected-apps': ConnectedAppsView,
    'deposit-view': DepositView,
    'deposited-exchange': DepositedExchangeView,
    'edit-profile': EditProfileView,
    'global-wallet': GlobalWalletView,
    'manage-mfa': ManageMfaWidgetView,
    'manage-mfa-no-footer': ManageMfaWidgetView,
    'manage-passkeys': ManagePasskeysWidgetView,
    profile: ProfileView,
    'receive-exchange-funds': ReceiveWalletFunds,
    'receive-wallet-funds': ReceiveWalletFunds,
    'send-balance': SendBalanceWidgetView,
    'session-management': SessionManagementView,
    'session-management-info': SessionManagementInfoView,
    'session-management-revoke-access': RevokeAccessView,
    settings: SettingsView,
    wallets: WalletsView,
};

export { mapViewToComponent };
